import type { TStatusPillVariant } from '@mopla/ui';

import { getMyTicketGroup } from '../../organisms/TicketsList/getMyTicketGroup';

import { IMyTicket, TMyTicketStatus } from './types';

/** Default chip variant per ticket status. */
const STATUS_VARIANT: Record<TMyTicketStatus, TStatusPillVariant> = {
	active: 'success',
	preorder: 'info',
	invalid: 'error',
	expired: 'info',
	cancelled: 'info',
};

/**
 * Chip variant for `status`, shared by the Tickets tab cards and the Ticket
 * Detail screen so the same ticket gets the same colour in both. Follows
 * `STATUS_VARIANT`, with one exception: a cancelled ticket whose validity has not
 * started yet still sits in the active group of the Tickets tab
 * (see `getMyTicketGroup`) and has an error (red) variant.
 * Once `validFrom` is reached the ticket moves to the Cancelled group and becomes grey.
 *
 * `status` is taken separately from the ticket because the detail screen
 * overrides the BE status once `validUntil` has passed.
 */
export const getMyTicketStatusVariant = (
	ticket: IMyTicket,
	status: TMyTicketStatus
): TStatusPillVariant =>
	status === 'cancelled' && getMyTicketGroup(ticket) === 'active'
		? 'error'
		: STATUS_VARIANT[status];
